import * as md from './icons-md'

const lg = md
const xl = md
const sm = md

export default {md, lg, sm, xl}